import type { PensionAsset } from "~/types/assets.types";

export const findSpecificGemel = (
  userProduct: PensionAsset,
  institutions: any[]
) => {
  const productInstitution = userProduct?.institution?.value;
  const productType = userProduct?.productType?.value;
  const route = userProduct?.route?.value;
  const number = Number(userProduct?.number?.value);

  if (!productInstitution || !productType || !route || !number) return;

  return institutions?.find(
    (institution) =>
      institution.brand === productInstitution &&
      institution.classification === productType &&
      institution.family === route &&
      institution.id === number
  );
};
